import { BiomarkerClassification } from '@/api/generated-catch-backend/model';

interface BiomarkerBadgeProps {
  classification: BiomarkerClassification;
}

const classificationConfig = {
  [BiomarkerClassification.pending]: {
    label: null, // Don't show badge for pending (not yet tested)
    bgColor: '',
  },
  [BiomarkerClassification.optimal]: {
    label: 'Optimal',
    bgColor: 'bg-catch-avocado-400',
  },
  [BiomarkerClassification.normal]: {
    label: 'Normal',
    bgColor: 'bg-catch-light-blue',
  },
  [BiomarkerClassification.out_of_range]: {
    label: 'Out of Range',
    bgColor: 'bg-catch-salmon',
  },
  [BiomarkerClassification.critical]: {
    label: 'Critical',
    bgColor: 'bg-catch-salmon',
  },
  [BiomarkerClassification.no_results]: {
    label: 'Missing Result',
    bgColor: 'bg-white',
  },
};

export function BiomarkerBadge({ classification }: BiomarkerBadgeProps) {
  const config = classificationConfig[classification];

  // Don't render badge for pending classification
  if (!config.label) {
    return null;
  }

  return (
    <span
      className={`inline-flex h-5 items-center justify-center gap-1 rounded px-1 py-1 text-xs font-medium text-catch-dark-blue-90 ${config.bgColor}`}
    >
      {config.label}
    </span>
  );
}
